import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService, ApConfirmModalService } from 'webcommon/core-ui';
import { FcModifyPhoneTypeListItemDto, FcPhoneTypeListItemDto } from 'webcommon/shared';
import { FcGenericItemModalBaseComponent } from '../../generic/fc-generic-item-modal-base.component';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'fc-phone-type-list-modal',
  templateUrl: './fc-phone-type-list-modal.component.html',
})
export class FcPhoneTypeListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-phone-type';
  public textConfirmationDialogOn =
    // eslint-disable-next-line max-len
    'You have set this phone type as SMS-enabled. This will flag all phone numbers of this phone type as allowing text messages. Click Confirm to save this change or click Cancel to discard your changes.';
  public textConfirmationDialogOff =
    // eslint-disable-next-line max-len
    'You have deselected the SMS-enabled flag. This will remove the SMS enabled flag for all phone numbers of this type. Click Confirm to save this change or click Cancel to discard your changes.';

  public listItem: FcPhoneTypeListItemDto;

  // Form Controls
  public externalIdControl: FormControl = new FormControl<string>('');
  public nameControl: FormControl = new FormControl<string>('');
  public notesControl: FormControl = new FormControl<string>('');
  public inactiveControl: FormControl = new FormControl<boolean>(false);
  public userDefinedControl: FormControl = new FormControl<boolean>(true);
  public smsEnabledDefaultControl: FormControl = new FormControl<boolean>(false);

  // Form Group
  public form = new FormGroup({
    externalId: this.externalIdControl,
    name: this.nameControl,
    notes: this.notesControl,
    inactive: this.inactiveControl,
    userDefined: this.userDefinedControl,
    smsEnabledDefault: this.smsEnabledDefaultControl,
  });

  constructor(injector: Injector, private confirmModalService: ApConfirmModalService) {
    super(injector);
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    // Load List Item and set default validation rules
    this.loadListItem({
      ExternalID: {
        MaxLength: 25,
      },
      Name: {
        IsRequired: true,
        MaxLength: 50,
      },
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  public setForm(): void {
    const userDefinedValue = this.listItem?.UserDefined ?? true;

    // External Id Control
    this.externalIdControl.setValidators(this.fcListValidation.getValidators('ExternalID'));
    this.externalIdControl.setValue(this.listItem?.ExternalID);

    // Name Control
    const isNameControlDisabled = !userDefinedValue;
    if (isNameControlDisabled) {
      this.nameControl.disable();
    }
    this.nameControl.setValidators(this.fcListValidation.getValidators('Name'));
    this.nameControl.setValue(this.listItem?.Name);

    // Notes Control
    this.notesControl.setValidators(this.fcListValidation.getValidators('Notes'));
    this.notesControl.setValue(this.listItem?.Notes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem?.Inactive || false);

    // User Defined Control
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(userDefinedValue);

    // Sms Enabled Default Control
    this.smsEnabledDefaultControl.setValue(this.listItem?.SmsEnabledDefault ?? false);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();

    const modifyItemDto: FcModifyPhoneTypeListItemDto = {
      ExternalID: this.externalIdControl.value,
      Name: values.name,
      Notes: values.notes,
      Inactive: values.inactive,
      UserDefined: values.userDefined,
      SmsEnabledDefault: values.smsEnabledDefault,
    };
    super.save<FcModifyPhoneTypeListItemDto>(modifyItemDto);
  }

  public showConfirm(e: PointerEvent): void {
    e.preventDefault();
    if (!this.smsEnabledDefaultControl.value) {
      this.confirmModalService
        .openModal(
          this.baseId,
          this.textConfirmationDialogOn,
          'SMS Enabled Changed',
          'Confirm',
          'Cancel',
          'emds-modal-small-fixed',
          null,
          null
        )
        .then((res) => {
          if (res) this.smsEnabledDefaultControl.setValue(true);
          this.form.markAsDirty();
        });
    } else {
      this.confirmModalService
        .openModal(
          this.baseId,
          this.textConfirmationDialogOff,
          'SMS Enabled Changed',
          'Confirm',
          'Cancel',
          'emds-modal-small-fixed',
          null,
          null
        )
        .then((res) => {
          if (res) this.smsEnabledDefaultControl.setValue(false);
          this.form.markAsDirty();

        });
    }
  }
}
